import axios from '../../../axios'

export default {
    namespaced: true,
    state: {
        currentLanguage: {},
    },
    getters: {
        getCurrentLanguage: (state) => state.currentLanguage,
    },
    mutations: {
        SET_CURRENT_LANGUAGE(state, payload) {
            state.currentLanguage = payload
        },
    },
    actions: {},
}
